import { SECOND } from '@sprytki-frontend-apps/common';
import { IMSpaceLockEvent } from 'api/interfaces/lockerGate';
import { makeAutoObservable } from 'mobx';

class MSpaceStore {
	private lockerId: string | null = null;
	private handleOpened?: (event: IMSpaceLockEvent) => void = undefined;
	private handleNotOpened?: (event: IMSpaceLockEvent) => void = undefined;
	private timeoutId: ReturnType<typeof setTimeout> | null = null;

	constructor() {
		makeAutoObservable(this);
	}

	processOpened = (event: IMSpaceLockEvent) => {
		if (this.lockerId !== event.lockerId) return;

		this.handleOpened?.(event);
		this.clear();
	};

	processNotOpened = (event: IMSpaceLockEvent) => {
		if (this.lockerId !== event.lockerId) return;

		this.handleNotOpened?.(event);
		this.clear();
	};

	onResult = (
		lockerId: string,
		onOpened: (event: IMSpaceLockEvent) => void,
		onNotOpened: (event: IMSpaceLockEvent) => void,
		onTimeoutCallback: () => void,
		timeoutMS: number = 20 * SECOND
	) => {
		this.clear();
		this.lockerId = lockerId;
		this.handleOpened = onOpened;
		this.handleNotOpened = onNotOpened;

		this.timeoutId = setTimeout(() => {
			this.clear();
			onTimeoutCallback?.();
		}, timeoutMS);
	};

	clear = () => {
		if (this.timeoutId) clearTimeout(this.timeoutId);
		this.timeoutId = null;
		this.lockerId = null;
		this.handleOpened = undefined;
		this.handleNotOpened = undefined;
	};
}

export const mSpaceStore = new MSpaceStore();
